export const STRAPI_URL =
  process.env.NEXT_PUBLIC_STRAPI_BASE_URL || "http://localhost:1337";

export const STRAPI_REVALIDATE_SECONDS = 60;
